export default "__VITE_ASSET__9ac4365f__"